<template>
    <div v-if="canShow" class="mod my-awards-notice">
        <div class="mod__hd">
            <h1 class="mod__h1 ta_center">领奖提醒</h1>
        </div>

        <div v-if="needBind" class="mod_bd">
            <div v-if="myOpenId" class="mod__txt">
                <dl>
                    <dd>&emsp;&emsp;恭喜您！</dd>
                    <dd>&emsp;&emsp;您的新浪账号<span class="red">{{myOpenNick}}</span>(<span class="blue">{{myOpenId}}</span>)绑定成功！</dd>
                    <dd>&emsp;&emsp;我们会将新浪《碎片化创新语音课》奖品权益发放到该账号；其他奖项，我们会在一周内开通权限、发送奖品。请及时查收你的奖品。</dd>
                    <dd>&emsp;&emsp;《碎片化创新语音课》: <a class="blue r-eid-vipAudioAward1" :href="getUrl('vipAudio')" style="text-decoration: underline">课程介绍</a> 、<a class="blue r-eid-vipAudioAward2" :href="getUrl('vipAudio2')" style="text-decoration: underline">更多帮助&gt;&gt;</a></dd>
                    <template v-if="needAddress && myAddress">
                    <dd>&nbsp;</dd>
                    <dd>&emsp;&emsp;您填写的领奖人信息如下：<br>&emsp;&emsp;收货人：<span class="red">{{myAddress.name}}</span> (<span class="blue">{{myAddress.mobile}}</span>)<br>&emsp;&emsp;地&emsp;址：{{myAddress.address}}
                    </dd>
                    </template>
                    <dd>&nbsp;</dd>
                    <dd>&emsp;&emsp;如有疑问请联系客服: <a class="blue" href="tel:4006776878" style="text-decoration: underline">400-677-6878</a>。</dd>
                </dl>
                <dl v-if="needAddress && !myAddress">
                    <dd>&emsp;</dd>
                    <dd class="red">由于发放实物奖品需要地址等信息，请填写你的领奖信息。</dd>
                    <dd>&nbsp;</dd>
                    <dd> </dd>
                </dl>
            </div>
            <div v-else class="mod__txt">
                <dl>
                    <dd>尊敬的用户您好！</dd>
                    <dd>&emsp;&emsp;为了保护的您的权益，请先绑定新浪账号，以便我们为您发放新浪《碎片化创新语音课》以及发放其他奖品，课程奖品将在一周内开通权限，实物奖品将在一周内递出，感谢您的配合！</dd>
                    <dd>&emsp;&emsp;请于
                        <k-txt-time :value="addressEnd" />之前完成操作，过期视为自动弃权，为了您的权益，请及时进行绑定，领取奖品！</dd>
                </dl>
            </div>
            <div class="mod__btns">
                <van-button v-if="!myOpenId" type="danger" size="big" block @click="goBind">绑定新浪账号</van-button>
                <van-button v-else-if="needAddress && !myAddress" type="danger" size="big" block @click="goAddress">填写领奖人信息</van-button>
            </div>
        </div>

        <!-- <div v-else-if="needAddress" class="mod_bd">
            <div class="mod__txt">
                <dl>
                    <dd>尊敬的用户您好！</dd>
                    <dd>&emsp;&emsp;请在
                        <k-txt-time :value="addressEnd" />之前填写你的个人信息，以便我们给你邮寄奖品以及发放相关服务权益。</dd>
                    <dd>&emsp;&emsp;过期未提交信息视为自动弃权，为了您的权益，请及时提交个人信息，领取奖品！</dd>
                </dl>
            </div>
            <div class="mod__btns">
                <van-button type="danger" size="big" block @click="goAddress">填写领奖信息</van-button>
            </div>
        </div> -->
    </div>
</template>

<script>
    import {
        mapState,
        mapGetters,
        mapActions
    } from 'vuex'

    export default {
        name: 'my-awards-notice',
        computed: {
            ...mapState(['oauthAddress', 'myOpenId', 'myOpenNick', 'myAddress', 'Urls']),
            ...mapGetters(['addressEnd', 'needBind', 'needAddress', 'isAfter', 'finalRes', 'getUrl']),
            canShow() {
                const {
                    isAfter,
                    finalRes,
                    needAddress,
                    needBind
                } = this
                return isAfter(finalRes) && (needAddress || needBind)
            }
        },
        methods: {
            ...mapActions(['loadMyOpenId', 'loadOauthAddress', 'goBind']),
            goAddress() {
                this.$router.push('/match/my/address')
            }
        },
        async created() {
            await this.loadMyOpenId()
            if (this.canShow) {
                if (!this.myOpenId) {
                    await this.loadOauthAddress()
                }
            }
        }
    };

</script>
